"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneyOriginDocumentValidationRules = void 0;
exports.MoneyOriginDocumentValidationRules = Object.freeze({
    maxFileSizeMb: 15,
    maxFilesPerUpload: 10,
    allowedMimeTypes: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.etsi.asic-e+zip',
        'application/edoc'
    ]
});
